require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-slogsdon-reasonably-reactive-rust.json") })
        }
      }, "path---package-unpublished-slogsdon-reasonably-reactive-rust");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-slogsdon-reasonably-reactive-rust!./.cache/json/package-unpublished-slogsdon-reasonably-reactive-rust.json
// module id = 963
// module chunks = 231608221292675